import { type MCPServerInfo } from '../../types';

const ScalrServer: MCPServerInfo = {
  serverId: 'SCALR',
  name: 'Scalr',
  slug: 'scalr',
  description:
    'Scalr MCP Server - Connect AI assistants to your Scalr platform for managing Terraform/OpenTofu infrastructure, workspaces, runs, environments, and IAM.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'scalr/mcp-server:latest',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'scalr/mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['scalrApiUrl', 'scalrApiToken'],
    properties: {
      scalrApiUrl: {
        type: 'string',
        description: 'Scalr instance URL (e.g., https://your-account.scalr.io)',
        sensitive: false
      },
      scalrApiToken: {
        type: 'string',
        description:
          'Scalr API token (Personal Access Token or Service Account Token). Create with minimum required permissions.',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default ScalrServer;
